import React from 'react'; 
import PortfolioPageTitle from './Components/Title';
import PortfolioSubSection from './Components/Section';
import PortfolioList from './Components/List';
import AddPortfolio from './Components/Portfolio';
const DashboardPortfolio = ()=> { 
    return (
      <div className="dashboard-portfolio">
          <div className="container mb-5">
            <div className="row">
              <div className="col-md-12">
                <h2>Portfolio Page</h2>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-5">
                  <PortfolioPageTitle/>
              </div>
            <div className="col-md-1"></div>
              <div className="col-md-5">
                <PortfolioSubSection/>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-11">
                <PortfolioList/>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-11">
                <AddPortfolio/>
              </div>
            </div>
          </div>
      </div>
    );
  }
  
  export default DashboardPortfolio; 